export default [
    {
      path: '/satisfactionsurvey',
      component: resolve => require(['@/components/satisfactionsurvey/satisfactionsurvey.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/satisfactionsurvey_write',
      component: resolve => require(['@/components/satisfactionsurvey/satisfactionsurvey_write.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/LearningProgramList',
      component: resolve => require(['@/components/satisfactionsurvey/LearningProgramList.vue'], resolve),
      meta: { requiresAuth: true }
    },
    {
      path: '/LearingFrame',
      component: resolve => require(['@/components/satisfactionsurvey/LearingFrame.vue'], resolve),
      meta: { requiresAuth: true }
    }
  ]



// WEBPACK FOOTER //
// ./src/components/satisfactionsurvey/index.js